/**
 * Utilitaires pour gérer les IDs composites dans Apollo Client
 * 
 * Les IDs sont construits comme suit:
 * - Post: foyerId/contextId/postId
 * - Group: foyerId (Group = Foyer)
 */

/**
 * Construit un ID composite pour un Post: foyerId/contextId/postId
 */
export function buildPostId(foyerId: string, contextId: string, postId: string): string {
  return `${foyerId}/${contextId}/${postId}`;
}

/**
 * Parse un ID composite de Post pour extraire foyerId, contextId et postId
 */
export function parsePostId(compositeId: string): { foyerId: string; contextId: string; postId: string } {
  const parts = compositeId.split('/');
  if (parts.length !== 3) {
    throw new Error(`Invalid Post ID format: ${compositeId}. Expected format: foyerId/contextId/postId`);
  }
  return {
    foyerId: parts[0],
    contextId: parts[1],
    postId: parts[2],
  };
}

/**
 * Construit un ID composite pour un Group: foyerId
 * (Group = Foyer, donc l'ID est simplement le foyerId)
 */
export function buildGroupId(foyerId: string): string {
  return foyerId;
}

/**
 * Parse un ID composite de Group pour extraire foyerId
 * Pour l'instant, Group ID = foyerId, donc on retourne directement
 */
export function parseGroupId(compositeId: string): { foyerId: string } {
  return {
    foyerId: compositeId,
  };
}

/**
 * Extrait le postId réel d'un ID composite de Post
 * Utile quand on a besoin de l'ID original pour les mutations
 */
export function extractPostIdFromComposite(compositeId: string): string {
  return parsePostId(compositeId).postId;
}

/**
 * Extrait le groupId réel d'un ID composite de Group
 * Utile quand on a besoin de l'ID original pour les mutations
 */
export function extractGroupIdFromComposite(compositeId: string): string {
  return parseGroupId(compositeId).foyerId;
}


